/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, region: NonNullable<unknown> }} Progression_Pain_No_SubstituteInputs */

const en_us2_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} hurt your ${i?.region}. Nothing safe replaces it. Talk to the trainer.`)
};

const pt_br2_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} doeu no ${i?.region}. Não há substituto seguro; fale com o treinador.`)
};

const es_419_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} te causó dolor en ${i?.region}. No hay sustituto seguro; habla con el entrenador.`)
};

const pt_pt2_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} causou dor no ${i?.region}. Não há substituto seguro; fala com o treinador.`)
};

const fr_fr2_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} t'a fait mal (${i?.region}). Rien de sûr ne peut le remplacer. Parles-en au coach.`)
};

const de_de2_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} hat Schmerzen verursacht (${i?.region}). Es gibt keinen sicheren Ersatz. Sprich mit dem Coach.`)
};

const it_it2_progression_pain_no_substitute = /** @type {(inputs: Progression_Pain_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} ti ha fatto male (${i?.region}). Nessun sostituto sicuro: parlane con il coach.`)
};

/**
* | output |
* | --- |
* | "{exercise} hurt your {region}. Nothing safe replaces it. Talk to the trainer." |
*
* @param {Progression_Pain_No_SubstituteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_pain_no_substitute = /** @type {((inputs: Progression_Pain_No_SubstituteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Pain_No_SubstituteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_pain_no_substitute(inputs)
	if (locale === "es-419") return es_419_progression_pain_no_substitute(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_pain_no_substitute(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_pain_no_substitute(inputs)
	if (locale === "de-DE") return de_de2_progression_pain_no_substitute(inputs)
	if (locale === "it-IT") return it_it2_progression_pain_no_substitute(inputs)
	return en_us2_progression_pain_no_substitute(inputs)
});
export { progression_pain_no_substitute as "progression.pain_no_substitute" }